import { useState } from "react";
import { DateTime } from "luxon";
import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowDownIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Label } from "shared/components";
import { DatePicker } from "shared/components/DatePickerCalendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from "shared/components/Popover";

export const CodeDateField = ({
  value,
  minDate,
  maxDays,
  onChange
}: {
  value: string;
  minDate: string;
  maxDays: number;
  onChange: (date: string) => void;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <Label htmlFor="code-start-date" showOptional={false}>
        Date
      </Label>
      <Popover open={open} onOpenChange={setOpen} placement="bottom-start">
        <PopoverTrigger asChild>
          <button
            id="code-start-date"
            type="button"
            onClick={() => setOpen((prev) => !prev)}
            className="flex h-12 w-full items-center justify-between rounded-md border border-alpha-100 bg-white pl-3.5 pr-1 text-left shadow-xs outline-none data-[state=open]:shadow-focus-ring"
          >
            <span className="text-base font-medium text-content-1000">
              {DateTime.fromISO(value).toFormat("ccc, LLL d")}
            </span>
            <span className="flex items-center p-2">
              <HugeiconsIcon
                icon={ArrowDownIcon}
                size={20}
                strokeWidth={2}
                className="text-alpha-100"
                aria-hidden
              />
            </span>
          </button>
        </PopoverTrigger>
        <PopoverContent className="z-[130] w-full max-w-[320px] overflow-hidden rounded-lg border border-alpha-100 bg-white shadow-lg">
          <DatePicker
            selectedDate={value}
            minDate={minDate}
            maxDays={maxDays}
            onSelectDate={(date) => {
              onChange(date);
              setOpen(false);
            }}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};
